function getCurrentPotTotal(pot: { patternId: number; value: number }[]) {
    let total = 0;

    if (pot !== undefined) {
        pot.map(({ value }) => {
            total += value;
        });
    }

    return total;
}

export default getCurrentPotTotal;
